import React from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import globals from '../globals'
import CustomLink from '../components/CustomLink'
import { connect } from 'react-redux'

const NavItem = (props) => {
    const renderChildren = props.children.map((item) => {
        if (props.residential && item.residentialOnly || !item.residentialOnly) {
            return (
                <li key={globals.convertToSlug(item.title)}>
                    <CustomLink
                        to={item.url}
                        className={`${item.active} gtm-site-nav-click`}
                        dangerouslySetInnerHTML={{ __html: item.title }}
                        onClick={event => handlePageChange(event)}
                    />
                </li>
            )
        }
    })

    const handleMouseEnter = (event) => {
        if (props.handleMouseEnter && !isTablet) {
            props.handleMouseEnter(event)
        }
    }

    const handleMouseLeave = (event) => {
        if (props.handleMouseLeave && !isTablet) {
            props.handleMouseLeave(event)
        }
    }

    const handleShowSubNav = (event) => {
        event.preventDefault()
        if (props.handleShowSubNav && !isTablet) {
            props.handleShowSubNav(event, props.title, props.identifier)
        }
    }

    const handlePageChangeParent = (event) => {
        if (props.handlePageChange && !isTablet) {
            props.handlePageChange(event)
        }
    }

    const handlePageChange = (event) => {
        if (props.closeAllSubNavs) {
            props.closeAllSubNavs()
        }

        if (props.handlePageChange) {
            props.handlePageChange(event)
        }
    }

    const handleParentTouch = (event) => {
        if (props.handleParentTouch && isTablet) {
            props.handleParentTouch(event)
        }
    }

    if (props.children.length > 0) {
        const MobileNav = () => {
            return (
                <li>
                    <a
                        href='#'
                        className={`${props.active} ${props.children.length > 0 ? 'has-children' : ''} gtm-site-nav-click`}
                        dangerouslySetInnerHTML={{ __html: props.title }}
                        onClick={handleShowSubNav.bind(this)}
                    />
                </li>
            )
        }

        const DesktopNav = () => {
            return (
                <li
                    onMouseEnter={handleMouseEnter.bind(this)}
                    onMouseLeave={handleMouseLeave.bind(this)}
                    onClick={handleParentTouch.bind(this)}
                >
                    <CustomLink
                        to={!isTablet ? props.url : '#'}
                        className={`hover-left ${props.active} ${props.children.length > 0 ? 'has-children' : ''} gtm-site-nav-click`}
                        dangerouslySetInnerHTML={{ __html: props.title }}
                        onClick={handlePageChangeParent.bind(this)}
                    />
                    <ul className='nav-dropdown'>
                        {!isMobile || isTablet ? renderChildren : ''}
                    </ul>
                </li>
            )
        }

        return (
            isMobile && !isTablet ? MobileNav() : DesktopNav()
        )
    } else {
        return (
            <li>
                <CustomLink
                    to={props.url}
                    className={`hover-left ${props.active} gtm-site-nav-click`}
                    onClick={handlePageChange.bind(this)}
                >
                    {props.title}
                </CustomLink>
            </li>
        )
    }
}

const mapStateToProps = state => ({
    residential: state.auth.residential
})

export default connect(mapStateToProps, {})(NavItem)



// WEBPACK FOOTER //
// ./resources/js/layout/NavItem.js